import { render, staticRenderFns } from "./inputMagic.vue?vue&type=template&id=fbd01482&scoped=true"
import script from "./inputMagic.vue?vue&type=script&lang=js"
export * from "./inputMagic.vue?vue&type=script&lang=js"
import style0 from "./inputMagic.vue?vue&type=style&index=0&id=fbd01482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd01482",
  null
  
)

export default component.exports